import { PhotoSquareOutlineIcon, TextOutlineIcon } from '@carboncopyco/icons';
import type { IVariableType } from '@carboncopyco/types';
import type { PopoverProps } from '@carboncopyco/ui';
import type { RuleSelectionOption } from '../RuleSelectionPopover';
import { RuleSelectionPopover } from '../RuleSelectionPopover';

const variableOptions: RuleSelectionOption<IVariableType>[] = [
  {
    value: 'text',
    icon: <TextOutlineIcon />,
    label: 'Text',
  },
  {
    value: 'image',
    icon: <PhotoSquareOutlineIcon />,
    label: 'Image',
  },
];

export interface VariableSelectionPopoverProps
  extends Pick<PopoverProps, 'triggerElement' | 'open' | 'onOpenChange'> {
  onSelect: (variableType: IVariableType) => void;
}

export const VariableSelectionPopover = ({
  triggerElement,
  open,
  onOpenChange,
  onSelect,
}: VariableSelectionPopoverProps) => {
  return (
    <RuleSelectionPopover
      open={open}
      onOpenChange={onOpenChange}
      triggerElement={triggerElement}
      options={variableOptions}
      onSelect={onSelect}
    />
  );
};
